'use client'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
    clearNotification,
    getNotification
} from '@/src/store/slices/notificationSlice'
import { Toast } from '@/src/ct-design/lib'
import { useAppSelector } from '@/src/store/hooks'

const NOTIFICATION_DURATION = 3000
const Notification = () => {
    const [visible, setVisible] = useState(false)
    const [animating, setAnimating] = useState(false)
    const dispatch = useDispatch()
    const { message, type } = useAppSelector(getNotification)

    useEffect(() => {
        if (message) {
            if (!animating) {
                setAnimating(true)
                setVisible(true)

                const timer = setTimeout(() => {
                    setVisible(false)

                    // After animation completes, clear the notification
                    setTimeout(() => {
                        setAnimating(false)
                        dispatch(clearNotification())
                    }, 300) // Animation duration
                }, NOTIFICATION_DURATION)

                // Clear timer if component unmounts or new notification arrives
                // return () => clearTimeout(timer)
            }
        }
    }, [message, dispatch, animating])

    const handleClose = () => {
        setVisible(false)
        setTimeout(() => {
            setAnimating(false)
            dispatch(clearNotification())
        }, 300)
    }

    return (
        <Toast
            message={message}
            visible={visible}
            type={type}
            onClose={handleClose}
        />
    )
}

export default Notification
